import { NESTED_ROUTES } from 'common/src/routes/BaseRoutes';

import { DASHBOARD_SLUGS } from 'portal/src/constants/luzmoDashboards';
import EvChargingView from 'portal/src/pages/evCharging/EvChargingView';
import isEvChargingViewEnabled from 'portal/src/pages/evCharging/isEvChargingViewEnabled';

import { RouteDefinition } from './routeGenerator';

export const evChargingRouteDefinitions: RouteDefinition[] = [
  {
    element: (
      <EvChargingView
        slug={DASHBOARD_SLUGS.EV_CHARGING.FACILITY}
        disabledSlug={DASHBOARD_SLUGS.EV_CHARGING.PREVIEW}
      />
    ),
    name: 'EV Facility Summary',
    path: NESTED_ROUTES.EV_CHARGING.FACILITY,
  },
  {
    element: <EvChargingView slug={DASHBOARD_SLUGS.EV_CHARGING.STATION} />,
    name: 'EV Station Summary',
    path: NESTED_ROUTES.EV_CHARGING.STATION,
    shouldRenderLink: isEvChargingViewEnabled,
  },
  {
    element: <EvChargingView slug={DASHBOARD_SLUGS.EV_CHARGING.SESSION} />,
    name: 'EV Session Summary',
    path: NESTED_ROUTES.EV_CHARGING.SESSION,
    shouldRenderLink: isEvChargingViewEnabled,
  },
];
